module.exports = __webpack_public_path__ + "static/media/13.7b187f31.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/13.png
// module id = 1118
// module chunks = 0